<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: Template
  Reason: Read-only flatten display of XxPerson rows with dynamic external side-car
          columns (ext_<typeFieldId>) for a selected ExternalPartyAssignment (TM-1000001960).
-->
@if (initialized) {
    <div class="flex flex-column gap-3">

        <!-- Assignment selector -->
        <p-panel header="Externe Partei / Zuordnung">
            <div class="flex align-items-center gap-2">
                <label for="xx-ext-assignment" class="font-medium">Externe Partei / Zuordnung</label>
                <p-select
                        inputId="xx-ext-assignment"
                        [options]="assignments"
                        [(ngModel)]="selectedAssignment"
                        (onChange)="onAssignmentSelect()"
                        [showClear]="true"
                        placeholder="Zuordnung auswählen"
                        appendTo="body"
                        styleClass="w-20rem">
                    <ng-template let-assignment pTemplate="selectedItem">
                        @if (assignment) {
                            <span>{{ resolveAssignmentLabel(assignment) }}</span>
                        }
                    </ng-template>
                    <ng-template let-assignment pTemplate="item">
                        <span>{{ resolveAssignmentLabel(assignment) }}</span>
                    </ng-template>
                </p-select>
            </div>
        </p-panel>

        <!-- Error state -->
        @if (errorMessage) {
            <p-message severity="error" [text]="errorMessage" styleClass="w-full"></p-message>
        }

        <!-- Loading state -->
        @if (loading) {
            <div class="flex justify-content-center align-items-center p-5 gap-2">
                <p-progressSpinner styleClass="w-3rem h-3rem" strokeWidth="4"></p-progressSpinner>
                <span class="text-color-secondary">Daten werden geladen…</span>
            </div>
        }

        <!-- Result section -->
        @if (!loading && selectedAssignment && !errorMessage) {
            <p-panel [header]="externalSectionTitle">

                @if (rows.length === 0) {
                    <p-message
                            severity="info"
                            text="Keine Personen mit externen Daten für diese Zuordnung gefunden."
                            styleClass="w-full"></p-message>
                } @else {
                    <p-table [value]="rows" [scrollable]="true" styleClass="p-datatable-sm">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Vorname</th>
                                <th>Nachname</th>
                                @for (col of externalColumns; track col.key) {
                                    <th>{{ col.header }}</th>
                                }
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-row>
                            <tr>
                                <td>{{ displayValue(row, 'firstName') }}</td>
                                <td>{{ displayValue(row, 'lastName') }}</td>
                                @for (col of externalColumns; track col.key) {
                                    <td>{{ displayValue(row, col.key) }}</td>
                                }
                            </tr>
                        </ng-template>
                    </p-table>
                }
            </p-panel>
        }

        <!-- Initial empty / no-selection hint -->
        @if (!loading && !selectedAssignment && !errorMessage) {
            <p-message
                    severity="info"
                    text="Bitte oben eine externe Partei / Zuordnung auswählen, um die externen Daten anzuzeigen."
                    styleClass="w-full"></p-message>
        }
    </div>
}
